import React from 'react';
import { observer } from 'mobx-react';
import { EventHubSubdomainFormVM } from './event-hub-subdomain-form.viewmodel';
import { FormattedMessage } from 'react-intl';
import WebsiteInput from '../../../../global/website-input/website-input';
import { FormField } from '../../../../global/form/form-field/form-field';
import { EventHubSubdomainFormField, FORM_CONFIG } from './event-hub-subdomain-form.config';
import { getEventHubRootDomain } from '../../../../../infrastructure/utils/common.utils';
import { CommonModal } from '../../../../global/modal/common/common-modal';
import { MANAGE_URL_TEXT } from '../../../event-hubs.text';
import DefaultButton from '../../../../global/default-button/default-button';
import { DefaultCloseModalButton } from '../../../../global/modal/common/common-close-modal-buttons';
import { applyText } from '../../../../../constants/common-labels.constants';
import './event-hub-subdomain-form.scss';

type EventHubSubdomainFormPresentationProps = {
    vm: EventHubSubdomainFormVM;
    isOpen: boolean;
    onRequestClose: () => void;
};

export const EventHubSubdomainFormPresentation = observer(({vm, isOpen, onRequestClose}: EventHubSubdomainFormPresentationProps): JSX.Element => {
    const { subdomain } = vm.getFormFields();

    return (
        <CommonModal
            title={<FormattedMessage {...MANAGE_URL_TEXT} />}
            isOpen={isOpen}
            onRequestClose={onRequestClose}
            footer={
                <div className='buttons-block buttons-block--from-right'>
                    <DefaultButton
                        text={applyText()}
                        modifier={['fat', 'confirm-safe']}
                        onClick={vm.submitForm}
                        disabled={vm.isLoading}
                    />
                    <DefaultCloseModalButton />
                </div>
            }
            className='manage-event-hub-url-modal'
        >
            <form className='oe-form event-hub-configuration-form'>
                <FormField label={<FormattedMessage {...FORM_CONFIG[EventHubSubdomainFormField.SUBDOMAIN].labelDescriptor} />}>
                    <WebsiteInput
                        onChange={e => subdomain.setValue(e.target.value)}
                        value={subdomain.value as string}
                        onBlur={subdomain.setTouched}
                        className='edit-passport-website-input'
                        postfix={getEventHubRootDomain()}
                    />
                    {subdomain.touched && !subdomain.valid && <ul className='oe-form-field__list-error'>
                        {((subdomain.validationMessage.defaultMessage as string).split('\n')).map((x, i) => <li key={i}>{x}</li>)}
                    </ul>}
                </FormField>
            </form>
        </CommonModal>
    );
});